export default function RecommendationCommentDirective() {
  return {
    template: require('./recommendation-comment.html'),
    scope: {
      recommendationId: '=',
      canEdit: '=',
      canDelete: '=',
      recommendationComment: '=',
    },
    controller: 'RecommendationCommentController',
    controllerAs: 'recommendationCommentVM',
    bindToController: true,
    replace: true
  };
}
